import React, { useEffect } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './ManualSignature.module.css';

const ManualSignatureComponent = React.forwardRef((props, ref) => {
  const { handleCheckSign, canvasWidth, canvasHeight, showModalHeader = false } = props;

  useEffect(() => {
    (function () {
      window.requestAnimFrame = ((callback) => {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function () {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
      function getMousePos(canvasDom, mouseEvent) {
        const rect = canvasDom.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top,
        };
      }

      function getTouchPos(canvasDom, touchEvent) {
        const rect = canvasDom.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top,
        };
      }

      const canvas = document.getElementById('sig-canvas');
      const ctx = canvas.getContext('2d');
      ctx.strokeStyle = '#222222';
      ctx.lineWidth = 4;

      let drawing = false;
      let drawingStarted = false;
      let mousePos = {
        x: 0,
        y: 0,
      };
      let lastPos = mousePos;

      canvas.addEventListener(
        'mousedown',
        function (e) {
          drawing = true;
          lastPos = getMousePos(canvas, e);
        },
        false
      );

      canvas.addEventListener(
        'mouseup',
        () => {
          drawing = false;
        },
        false
      );

      canvas.addEventListener(
        'mousemove',
        (e) => {
          mousePos = getMousePos(canvas, e);
        },
        false
      );

      // Add touch event support for mobile
      canvas.addEventListener('touchstart', () => {}, false);

      canvas.addEventListener(
        'touchmove',
        (e) => {
          const touch = e.touches[0];
          const me = new MouseEvent('mousemove', {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(me);
        },
        false
      );

      canvas.addEventListener(
        'touchstart',
        (e) => {
          mousePos = getTouchPos(canvas, e);
          const touch = e.touches[0];
          const me = new MouseEvent('mousedown', {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(me);
        },
        false
      );

      canvas.addEventListener(
        'touchend',
        () => {
          const me = new MouseEvent('mouseup', {});
          canvas.dispatchEvent(me);
        },
        false
      );

      function renderCanvas() {
        if (drawing) {
          ctx.moveTo(lastPos.x, lastPos.y);
          ctx.lineTo(mousePos.x, mousePos.y);
          ctx.stroke();
          lastPos = mousePos;
          if (!drawingStarted) {
            drawingStarted = true;
            handleCheckSign(true);
          }
        }
      }

      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        'touchstart',
        (e) => {
          if (e.target === canvas) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchend',
        (e) => {
          if (e.target === canvas) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        'touchmove',
        (e) => {
          if (e.target === canvas) {
            e.preventDefault();
          }
        },
        false
      );

      (function drawLoop() {
        window.requestAnimFrame(drawLoop);
        renderCanvas();
      })();

      function clearCanvas() {
        // eslint-disable-next-line no-self-assign
        canvas.width = canvas.width;
        ctx.strokeStyle = '#222222';
        ctx.lineWidth = 4;
        drawingStarted = false;
        handleCheckSign(false);
      }

      // Set up the UI
      const clearBtn = document.getElementById('sig-clearBtn');
      clearBtn.addEventListener(
        'click',
        function () {
          clearCanvas();
        },
        false
      );
    })();
  }, []);

  return (
    <Grid>
      <Grid.Row style={showModalHeader ? {} : { padding: 0, margin: 0 }}>
        <Grid.Column id="canvas-col">
          <canvas ref={ref} id="sig-canvas" width={canvasWidth} height={canvasHeight} className={styles.sigCanvas}>
            Get a better browser, bro.
          </canvas>
          {props?.signetureError && <div className="errorText">*{props?.signetureError}</div>}

          <Button id="sig-clearBtn" className="new simple" type="button">
            Clear Signature
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
});

ManualSignatureComponent.propTypes = {
  handleCheckSign: PropTypes.func.isRequired,
  signetureError: PropTypes.string,
  canvasWidth: PropTypes.string,
  canvasHeight: PropTypes.string,
  showModalHeader: PropTypes.bool,
};

export default React.memo(ManualSignatureComponent);
